import type { RawButtonProps } from '@ps/web-shared-components';
import React from 'react';

import type { Tournament } from '../../types/MTT';

import Empty from './Empty/Empty';
import NameBar from './TournamentCard/NameBar/NameBar';
import State from './TournamentCard/State/State';
import TournamentCard from './TournamentCard/TournamentCard';
import Buttons from './TournamentInfo/Buttons/Buttons';
import LobbyButton from './TournamentInfo/Buttons/LobbyButton/LobbyButton';
import BuyIn from './TournamentInfo/BuyIn/BuyIn';
import InfoItemsContainer from './TournamentInfo/InfoItemsList/InfoItemsContainer';
import SatelliteInfo from './TournamentInfo/SatelliteInfo/SatelliteInfo';
import Tags from './TournamentInfo/Tags/Tags';
import TournamentInfo from './TournamentInfo/TournamentInfo';
import WinnerItem from './TournamentInfo/WinnerItem/WinnerItem';

export interface SidecarProps {
  tournament: Tournament;
  buttonsSize?: RawButtonProps['size'];
  classes?: {
    buttonsRoot?: string;
    buttonRegister?: string;
    infoContainer?: string;
    card?: string;
  };
}

interface SidecarComponents {
  Buttons: typeof Buttons;
  BuyIn: typeof BuyIn;
  Card: typeof TournamentCard;
  Empty: typeof Empty;
  Info: typeof TournamentInfo;
  InfoItems: typeof InfoItemsContainer;
  LobbyButton: typeof LobbyButton;
  NameBar: typeof NameBar;
  SatelliteInfo: typeof SatelliteInfo;
  State: typeof State;
  Tags: typeof Tags;
  WinnerItem: typeof WinnerItem;
}

const Sidecar: React.FC<SidecarProps> & SidecarComponents = ({
  tournament,
  classes,
  buttonsSize = 'small'
}) => (
  <>
    <TournamentCard
      className={classes?.card}
      fallbackImageUrl={tournament.fallbackImageUrl}
      imageUrl={tournament.imageUrl}
      state={tournament.formattedState}
      tournamentName={tournament.formattedSidecarName}
    />
    <TournamentInfo className={classes?.infoContainer}>
      <Tags tags={tournament.tags} />
      <BuyIn tournament={tournament} />
      <InfoItemsContainer tournament={tournament} />
      <Buttons
        tournament={tournament}
        classes={{ root: classes?.buttonsRoot, register: classes?.buttonRegister }}
        size={buttonsSize}
      />
    </TournamentInfo>
  </>
);

Sidecar.Buttons = Buttons;
Sidecar.BuyIn = BuyIn;
Sidecar.Card = TournamentCard;
Sidecar.Empty = Empty;
Sidecar.Info = TournamentInfo;
Sidecar.InfoItems = InfoItemsContainer;
Sidecar.LobbyButton = LobbyButton;
Sidecar.NameBar = NameBar;
Sidecar.SatelliteInfo = SatelliteInfo;
Sidecar.State = State;
Sidecar.Tags = Tags;
Sidecar.WinnerItem = WinnerItem;

export default Sidecar;
